exceptionHandler.$inject = ['$provide'];

export default function exceptionHandler($provide) {
	$provide.decorator("$exceptionHandler", ['$delegate', '$window', function ($delegate, $window) {
		return function (exception, cause) {
			$delegate(exception, cause);
			// Send angular errors to Rollbar
			if ($window.Rollbar) {
				$window.Rollbar.error(exception, {
					cause: cause
				});
			}
		};
	}]);
};



// WEBPACK FOOTER //
// ./project/apps/factbox-app/factbox-app.exceptions.js